import React from 'react';

import ListWithFlex from './ListWithFlex';
import ListWithGrid from './ListWithGrid';

const List = ({
  listLayout,
  renderItem,
  items,
  columns,
  childSpacing,
  minMaxWidth,
  gap,
  ...props
}) => {
  switch (listLayout) {
    case 'GridList': {
      return (
        <ListWithGrid
          renderItem={renderItem}
          items={items}
          minMaxWidth={minMaxWidth}
          gap={gap}
          {...props}
        />
      );
    }
    case 'FlexHorizontalList':
    default: {
      return (
        <ListWithFlex
          renderItem={renderItem}
          items={items}
          columns={columns}
          childSpacing={childSpacing}
          {...props}
        />
      );
    }
  }
};

export default List;
